/* Shared section FX engine. Opt-in per element via data-attributes:
   - [data-fx-tilt="8"]      3D tilt toward the cursor (deg). Adds a .fx-glare child
                             (into [data-fx-glare] within it, else the element itself).
   - [data-fx-stagger]       direct children fade/rise in, staggered, when scrolled into view.
   - [data-fx-parallax="0.12"] element drifts on scroll (sets --fx-par).
   Desktop/fine-pointer gating for tilt + parallax; reduced-motion disables motion. */
(function () {
  var mm = window.matchMedia ? window.matchMedia.bind(window) : null;
  var fine = mm ? mm('(pointer: fine)').matches : false;
  var reduce = mm ? mm('(prefers-reduced-motion: reduce)').matches : false;

  function bindTilt(el) {
    if (el.__fxTilt) return;
    el.__fxTilt = true;
    el.style.transformStyle = 'preserve-3d';
    el.style.willChange = 'transform';
    var max = parseFloat(el.getAttribute('data-fx-tilt')) || 8;
    var glare = document.createElement('span');
    glare.className = 'fx-glare';
    glare.setAttribute('aria-hidden', 'true');
    (el.querySelector('[data-fx-glare]') || el).appendChild(glare);

    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      el.style.transition = 'transform 0.08s linear';
      el.style.transform =
        'perspective(900px) rotateX(' + ((0.5 - py) * max).toFixed(2) + 'deg) rotateY(' +
        ((px - 0.5) * max).toFixed(2) + 'deg)';
      glare.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
      glare.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
      glare.style.opacity = '1';
    });
    el.addEventListener('pointerleave', function () {
      el.style.transition = 'transform 0.5s cubic-bezier(0.2, 0.7, 0.2, 1)';
      el.style.transform = '';
      glare.style.opacity = '0';
    });
  }

  function bindStagger(container) {
    if (container.__fxStagger) return;
    container.__fxStagger = true;
    var kids = container.children;
    for (var i = 0; i < kids.length; i++) kids[i].style.setProperty('--fx-i', i);
    container.classList.add('fx-stagger');
    if (!('IntersectionObserver' in window)) { container.classList.add('fx-in'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('fx-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    io.observe(container);
  }

  function bindParallax(el) {
    if (el.__fxPar) return;
    el.__fxPar = true;
    var speed = parseFloat(el.getAttribute('data-fx-parallax')) || 0.12;
    var ticking = false;
    function update() {
      ticking = false;
      var r = el.getBoundingClientRect();
      var fromCenter = (r.top + r.height / 2) - (window.innerHeight / 2);
      el.style.setProperty('--fx-par', (-fromCenter * speed).toFixed(1) + 'px');
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function run(root) {
    root = root || document;
    var q = function (sel) { return root.querySelectorAll(sel); };
    if (fine && !reduce) Array.prototype.forEach.call(q('[data-fx-tilt]'), bindTilt);
    if (!reduce) Array.prototype.forEach.call(q('[data-fx-stagger]'), bindStagger);
    if (fine && !reduce) Array.prototype.forEach.call(q('[data-fx-parallax]'), bindParallax);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', function (e) { run(e.target || document); });
})();
